import { Route } from 'i18n/utils'
import * as auth from 'auth'
import LoginSignUpContainer from '@components/LoginSignUpContainer'
import featureToggles from 'shared/featureToggles'

import { dashboardBackgroundSelector, promotionsSelector } from '../selectors'

import Header from './Header'
import { isArrayValid } from './utils'

const menuItems = withPromotion => [
    {
        name: 'dashboard.menu.index',
        path: 'dashboard',
    },
    {
        name: 'dashboard.menu.transactions',
        path: 'dashboard/transactions',
    },
    featureToggles.newSubscriptionDashboard && {
        name: 'dashboard.menu.subscriptions',
        path: 'dashboard/subscriptions',
    },
    {
        name: 'dashboard.menu.vehicles',
        path: 'dashboard/vehicles',
    },
    {
        name: 'dashboard.menu.cards',
        path: 'dashboard/credit-cards',
    },
    withPromotion && {
        name: 'dashboard.menu.promotions',
        path: 'dashboard/promotions',
    },
    {
        name: 'dashboard.menu.account',
        path: 'dashboard/account',
    },
]

const DashboardContainerComponent = ({ user, background, promotions, children, hasMenu = true, hasGreeting = true }) =>
    user ? (
        <div className="dashboard-container">
            <Header background={background} menuItems={menuItems(isArrayValid(promotions))} hasMenu={hasMenu} />

            {hasGreeting && (
                <h2>
                    <T>dashboard.user.greeting</T>{' '}
                    <span className="name">
                        {user.details.firstName} {user.details.lastName}
                    </span>
                </h2>
            )}

            {children}
        </div>
    ) : (
        <div className="dashboard-container mt-6">
            <div className="dashboard-inner-container ">
                <LoginSignUpContainer title={<T>dashboard.user.login.required.message</T>} />
            </div>
        </div>
    )

const DashboardContainer = connect(
    createStructuredSelector({
        user: auth.selectors.userSelector,
        background: dashboardBackgroundSelector,
        promotions: promotionsSelector,
    })
)(DashboardContainerComponent)

const DashboardRoute = ({ component: Component, hasMenu, hasGreeting, ...rest }) => (
    <Route
        {...rest}
        render={() => (
            <DashboardContainer hasMenu={hasMenu} hasGreeting={hasGreeting}>
                <Component />
            </DashboardContainer>
        )}
    />
)

export default DashboardRoute
